/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetLanguageLocalesResult } from '../../models/get-language-locales-result';

export interface ApiLanguagesLanguageLocalesGet$Params {
}

export function apiLanguagesLanguageLocalesGet(http: HttpClient, rootUrl: string, params?: ApiLanguagesLanguageLocalesGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetLanguageLocalesResult>> {
  const rb = new RequestBuilder(rootUrl, apiLanguagesLanguageLocalesGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetLanguageLocalesResult>;
    })
  );
}

apiLanguagesLanguageLocalesGet.PATH = '/api/Languages/language-locales';
